import { DashboardService, toastr, SUCCESS_REPONSE_CODE, UNPROCESSABLE_ENTITY_RESPONSE_CODE, handleOtherResponseCode,
     REDIRECT, ErrorPages, CustomToastrAction, MergeRecordsService, CommonAction} from '@/imports-files/pages/clients/activities/index';

export class CandidateMergeAction
{
  constructor(args)
  {
    this.setApiError = args.setApiError
    this.setFlagForRerender = args.setFlagForRerender
    this.router = args.router
    this.setAgencyAcceptReject = args.setAgencyAcceptReject
    this.mergeRecordsService  = new MergeRecordsService()
    this.customToastrAction   =   new CustomToastrAction();

    this.activitiesData = args.activitiesData
    this.setActivitiesData = args.setActivitiesData

    this.setJobData = args.setJobData
  }

  async showAcceptReject(data)
  {
    this.setAgencyAcceptReject({ status: true, confirmBtnAction: () => { this.confirmAcceptApplication(data)}, declineBtnAction: () => { this.confirmRejectApplication(data)} , button1_text: 'Decline', button2_text: 'Accept', viewData: data.details})
  }

  async confirmAcceptApplication(data)
  {
    let body = {job_application_id: data.details.job_application_id, duplicate_application_id: data.details.duplicate_application_id, notification_id: data.id}
    if(data.from) body.from = 'kanban'
    var result = await this.mergeRecordsService.acceptAgencyApplication(body)
    this.setApiError(result.request);
    const status_code   =   result.status || result.response.status;

    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        this.setAgencyAcceptReject({ status: false, message: '', confirmBtnAction: '', declineBtnAction: '', button1_text: 'Cancel', button2_text: 'Dismiss' });
        this.customToastrAction.setNormalToastr(result.data.success, 'success');
        if(data.from == 'kanban'){
          this.setJobData(result.data.kanban_data)
        }
        else{
          this.activitiesData.alerts = result.data.data.alerts;
          this.setActivitiesData(this.activitiesData)
        }
        this.setFlagForRerender(Math.random() * 10000);
        break;
      default:
        this.setAgencyAcceptReject({ status: false, message: '', confirmBtnAction: '', declineBtnAction: '', button1_text: 'Cancel', button2_text: 'Dismiss' });
        this.customToastrAction.setNormalToastr(result.request.error, 'success');
        this.setFlagForRerender(Math.random() * 10000);
    }
  }

  async confirmRejectApplication(data)
  {
    let body = {duplicate_application_id: data.details.duplicate_application_id, agency_user_id: data.details.agency_user_id, notification_id: data.id}
    if(data.from) body.from = 'kanban'
    var result = await this.mergeRecordsService.rejectAgencyApplication(body)
    this.setApiError(result.request);
    const status_code   =   result.status || result.response.status;

    switch (status_code)
    {
      case SUCCESS_REPONSE_CODE:
        this.setAgencyAcceptReject({ status: false, message: '', confirmBtnAction: '', declineBtnAction: '', button1_text: 'Cancel', button2_text: 'Dismiss' });
        this.customToastrAction.setNormalToastr(result.data.success, 'success');
        if(data.from == 'kanban'){
          this.setJobData(result.data.kanban_data)
        }
        else{
          this.activitiesData.alerts = result.data.data.alerts;
          this.setActivitiesData(this.activitiesData)
        }
        this.setFlagForRerender(Math.random() * 10000);
        break;
      default:
        this.setAgencyAcceptReject({ status: false, message: '', confirmBtnAction: '', declineBtnAction: '', button1_text: 'Cancel', button2_text: 'Dismiss' });
        this.customToastrAction.setNormalToastr(result.request.error, 'success');
        this.setFlagForRerender(Math.random() * 10000);
    }
  }
}